import { Navigate, Outlet } from "react-router-dom";
import LayoutApp from "../Layouts/Application/LayoutApp";
import ErrorPage from "../Layouts/Application/ErrorPage";
import Login from "../pages/Auth/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import Settings from "../pages/Settings/Settings";
import GuestLayoutApp from "../Layouts/Application/GuestLayoutApp";
import PasswordReset from "../pages/Auth/PasswordReset";
import NewPassword from "../pages/Auth/NewPassword";
import NewsletterManagement from "../pages/NewsletterManagement";
import SubscriberManagement from "../pages/SubscriberManagement";

import CategoryList from "../pages/Blogs/Category/CategoryList";
import AddOrUpdateCategory from "../pages/Blogs/Category/AddOrUpdateCategory";
import AddPost from "../pages/Blogs/Post/AddOrUpdatePost";
import PostList from "../pages/Blogs/Post/PostList";
import CommentList from "../pages/Blogs/Comments/CommentList";
import AddOrUpdateComment from "../pages/Blogs/Comments/AddOrUpdateComment";

import CommunityCategoryList from "../pages/Community/Category/CategoryList";
import CommunityAddOrUpdateCategory from "../pages/Community/Category/AddOrUpdateCategory";
import CommunityPostList from "../pages/Community/Post/PostList";
import CommunityCommentList from "../pages/Community/Comments/CommentList";
import CommunityAddOrUpdateComment from "../pages/Community/Comments/AddOrUpdateComment";

import { PostProvider } from "../context/postContext";
import UserList from "../pages/Users/pages/UserList";

import TutorList from "../pages/Tutors/pages/TutorList";

import StudentList from "../pages/Students/pages/StudentList";
import ParentList from "../pages/Parents/pages/ParentList";
import ParentDetails from "../pages/Parents/pages/ParentDetails";
import AssociationRequestList from "../pages/AssociationRequests/AssociationRequestList";
import AssociationRequestDetails from "../pages/AssociationRequests/AssociationRequestDetails";

import PrivateRequest from "../pages/PrivateRequest/Post/PostList";

import UserDetails from "../pages/Users/pages/UserDetails";
import { PostCommentProvider } from "../context/postCommentContext";
import CommunityRequestCommentList from "../pages/Community/Post/CommunityRequestCommentList";
import BlogPostCommentList from "../pages/Blogs/Post/BlogPostCommentList";
import GuestbookManagement from "../pages/Guestbook/GuestbookManagement";
import AdminList from "../pages/Admins/pages/AdminList";
import AdminDetails from "../pages/Admins/pages/AdminDetails";
import AddOrUpdateAdmin from "../pages/Admins/pages/AddOrUpdateAdmin";
import QuestionList from "../pages/Surveys/Questions/QuestionList";
import AddOrUpdateQuestion from "../pages/Surveys/Questions/AddOrUpdateQuestion";
import ResponseList from "../pages/Surveys/Responses/ResponseList";
import ResponseDetails from "../pages/Surveys/Responses/ResponseDetails";
import SurveyAnalytics from "../pages/Surveys/Analytics/SurveyAnalytics";
import BookingList from "../pages/Bookings/BookingList";
import BookingDetails from "../pages/Bookings/BookingDetails";
import OrderList from "../pages/Orders/OrderList";
import OrderDetails from "../pages/Orders/OrderDetails";
import CourseList from "../pages/Courses/CourseList";
import CourseEditor from "../pages/Courses/CourseEditor";
import ExerciseList from "../pages/Courses/ExerciseList";
import ExerciseEditor from "../pages/Courses/ExerciseEditor";
import CourseDetails from "../pages/Courses/CourseDetails";
import ExerciseDetails from "../pages/Courses/ExerciseDetails";

const routes = (isLoggedIn: boolean) => [
  {
    path: "/app",
    element: isLoggedIn ? <LayoutApp /> : <Navigate to="/login" />,
    errorElement: <ErrorPage />,
    children: [
      { path: "dashboard", element: <Dashboard /> },
      { path: "settings", element: <Settings /> },
      {
        path: "newsletter",
        element: <Outlet />,
        children: [
          { index: true, element: <NewsletterManagement /> },
          { path: "subscribers", element: <SubscriberManagement /> },
        ],
      },
      {
        path: "blog",
        element: <Outlet />,
        children: [
          {
            path: "category",
            element: <Outlet />,
            children: [
              { index: true, element: <CategoryList /> },
              { path: "create", element: <AddOrUpdateCategory /> },
            ],
          },
          {
            path: "comments",
            element: (
              <PostCommentProvider>
                <Outlet />
              </PostCommentProvider>
            ),
            children: [
              { index: true, element: <CommentList /> },
              { path: "create", element: <AddOrUpdateComment /> },
            ],
          },
          {
            path: "posts",
            element: (
              <PostProvider>
                {" "}
                <Outlet />{" "}
              </PostProvider>
            ),
            children: [
              { index: true, element: <PostList /> },
              {
                path: "create",
                element: <AddPost />,
              },
              {
                path: ":id/edit",
                element: <AddPost />,
              },
              {
                path: ":id/comments",
                element: <BlogPostCommentList />,
              },
            ],
          },
        ],
      },
      {
        path: "community",
        element: <Outlet />,
        children: [
          {
            path: "category",
            element: <Outlet />,
            children: [
              { index: true, element: <CommunityCategoryList /> },
              { path: "create", element: <CommunityAddOrUpdateCategory /> },
            ],
          },
          {
            path: "comments",
            element: (
              <PostCommentProvider>
                <Outlet />
              </PostCommentProvider>
            ),
            children: [
              { index: true, element: <CommunityCommentList /> },
              { path: "create", element: <CommunityAddOrUpdateComment /> },
            ],
          },
          {
            path: "requests",
            element: (
              <PostProvider>
                {" "}
                <Outlet />{" "}
              </PostProvider>
            ),
            children: [
              { index: true, element: <CommunityPostList /> },
              {
                path: ":id/comments",
                element: <CommunityRequestCommentList />,
              },
            ],
          },
        ],
      },

      {
        path: "tutors",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: (
              <PostProvider>
                {" "}
                <TutorList />{" "}
              </PostProvider>
            ),
          },
          {
            path: ":id/view",
            element: <UserDetails />,
          },
        ],
      },

      {
        path: "private-requests",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: (
              <PostProvider>
                {" "}
                <PrivateRequest />{" "}
              </PostProvider>
            ),
          },
          {
            path: ":id/view",
            element: <UserDetails />,
          },
        ],
      },

      {
        path: "students",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: (
              <PostProvider>
                {" "}
                <StudentList />{" "}
              </PostProvider>
            ),
          },
          {
            path: ":id/view",
            element: <UserDetails />,
          },
        ],
      },
      {
        path: "parents",
        element: <Outlet />,
        children: [
          { index: true, element: <ParentList /> },
          { path: ":id/view", element: <ParentDetails /> },
        ],
      },
      {
        path: "association-requests",
        element: <Outlet />,
        children: [
          { index: true, element: <AssociationRequestList /> },
          { path: ":id/view", element: <AssociationRequestDetails /> },
        ],
      },
      {
        path: "users",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: (
              <PostProvider>
                {" "}
                <UserList />{" "}
              </PostProvider>
            ),
          },
          {
            path: ":id/view",
            element: <UserDetails />,
          },
        ],
      },
      {
        path: "admins",
        element: <Outlet />,
        children: [
          { index: true, element: <AdminList /> },
          { path: "create", element: <AddOrUpdateAdmin /> },
          { path: ":id/view", element: <AdminDetails /> },
          { path: ":id/edit", element: <AddOrUpdateAdmin /> },
        ],
      },
      {
        path: "guestbook",
        element: <GuestbookManagement />,
      },
      {
        path: "bookings",
        element: <Outlet />,
        children: [
          { index: true, element: <BookingList /> },
          { path: ":id", element: <BookingDetails /> },
        ],
      },
      {
        path: "orders",
        element: <Outlet />,
        children: [
          { index: true, element: <OrderList /> },
          { path: ":id", element: <OrderDetails /> },
        ],
      },
      {
        path: "courses",
        element: <Outlet />,
        children: [
          { index: true, element: <CourseList /> },
          { path: "create", element: <CourseEditor /> },
          { path: ":id/edit", element: <CourseEditor /> },
          { path: ":id/details", element: <CourseDetails /> },
          {
            path: "exercises",
            element: <Outlet />,
            children: [
              { index: true, element: <ExerciseList /> },
              { path: "create", element: <ExerciseEditor /> },
              { path: ":id/edit", element: <ExerciseEditor /> },
              { path: ":id/details", element: <ExerciseDetails /> },
            ],
          },
        ],
      },
      {
        path: "surveys",
        element: <Outlet />,
        children: [
          {
            path: "questions",
            element: <Outlet />,
            children: [
              { index: true, element: <QuestionList /> },
              { path: "create", element: <AddOrUpdateQuestion /> },
              { path: ":id/edit", element: <AddOrUpdateQuestion /> },
            ],
          },
          {
            path: "responses",
            element: <Outlet />,
            children: [
              { index: true, element: <ResponseList /> },
              { path: ":id", element: <ResponseDetails /> },
            ],
          },
          {
            path: "analytics",
            element: <SurveyAnalytics />,
          },
        ],
      },
      // { path: "/", element: <Navigate to="/app/dashboard" /> },
    ],
  },

  {
    path: "/",
    element: !isLoggedIn ? (
      <GuestLayoutApp />
    ) : (
      <Navigate to="/app/dashboard" />
    ),
    errorElement: <ErrorPage />,
    children: [
      { path: "login", element: <Login /> },
      { path: "/password_reset/:token", element: <NewPassword /> },
      { path: "/password_reset", element: <PasswordReset /> },
      { path: "/", element: <Login /> },
    ],
  },
];

export default routes;
